<template>
  <div>
    <div class="d-flex justify-content-center align-items-center" style="width: 100%; height: 100%; position: absolute;">
      <div class="loginBox">
        <div class="d-flex justify-content-center align-items-center">
          <div id="logoBox">
          <Logo :fill="'#000000'" :height="'33px'" :width="'33px'" class="mb-0 me-2 d-flex align-items-center"></Logo> <span id="logotext"> Portal</span>
          </div>
        </div>
        <div v-if="error" class="d-flex alert alert-danger error">{{error}}</div>
        <form action="#" @submit.prevent="submit">
          <div class="form-group">
            <div>
              <label>{{$t('login.email')}}</label>
              <div class="input-group mb-3">
                <span class="input-group-text"><font-awesome-icon :icon="['far', 'envelope']" /></span>
                <input                     
                  id="email"
                  type="email"
                  class="form-control"
                  name="email"
                  value
                  required
                  autofocus
                  v-model="form.email"/>
              </div>
            </div>
          </div>
          <div>
            <div>
              <label>{{$t('login.password')}}</label>
              <div class="input-group mb-3">
                <span class="input-group-text"><font-awesome-icon :icon="['far', 'key']" /></span>
                <input                     
                  id="password"
                  type="password"
                  class="form-control"
                  name="password"
                  required
                  v-model="form.password"/>
              </div>
            </div>
          </div>
          <div class="form-group mt-4">
            <button type="submit" class="btn btn-primary w-100">{{$t('login.login')}}</button>
          </div>
        </form>
        <div class="text-center mt-3">
          <router-link  :class="`nav-link`" :to="`/password-reset`">{{$t('login.password_reset')}}</router-link >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getAuth, signInWithEmailAndPassword} from "firebase/auth";
import { functions } from "../plugins/firebase"
import { httpsCallable } from "firebase/functions";
import Logo from '../assets/Logo'

export default {
  name: 'InAppLoginComponent',
  components:{
    Logo,
  },
  data() {
    return {
      form: {
        email: "",
        password: ""
      },
      error: null
    };
  },
  methods: {
    submit() {
      signInWithEmailAndPassword(getAuth(), this.form.email, this.form.password)
      .then(() => {
        const getUserTokenFromTool = httpsCallable(functions, 'getUserTokenFromTool');
        getUserTokenFromTool({toolId: this.$route.params.appId})
        .then((response)=>{
          const token = response.data
          window.location.replace("chargeLine://"+token);
        })
        .catch(err=>{
          console.log(err)
        })

      })
      .catch(err => {
        this.error = err.message;
      });
    },
  },
  mounted(){
  }

};
</script>